import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AlertsService from 'cio/services/alerts';
import RouterService from '@ember/routing/router-service';
import MasqService from 'cio/services/masq';
import AuthService from 'cio/services/auth';

export default class ActionsRoute extends Route {
  @service alerts!: AlertsService;
  @service auth!: AuthService;
  @service masq!: MasqService;
  @service router!: RouterService;
}
